(() => {
  if (window.__mymaraRestockLoaded) return;
  window.__mymaraRestockLoaded = true;
  const messages = {
    en: {loading:'Saving your alert…', success:'We will email you when {item} is available.', error:'Could not save your alert. Please try again.', cancel:'Cancel alert'},
    et: {loading:'Salvestan teavitust…', success:'Saadame sulle kirja, kui {item} on taas saadaval.', error:'Teavituse salvestamine ebaõnnestus. Proovi uuesti.', cancel:'Tühista teavitus'},
    es: {loading:'Guardando tu alerta…', success:'Te enviaremos un correo cuando {item} vuelva a estar disponible.', error:'No se pudo guardar la alerta. Inténtalo de nuevo.', cancel:'Cancelar alerta'},
    de: {loading:'Benachrichtigung wird gespeichert…', success:'Wir senden dir eine E-Mail, sobald {item} wieder verfügbar ist.', error:'Die Benachrichtigung konnte nicht gespeichert werden. Bitte versuche es erneut.', cancel:'Benachrichtigung abbestellen'},
    lv: {loading:'Saglabājam paziņojumu…', success:'Nosūtīsim jums e-pastu, kad {item} atkal būs pieejams.', error:'Paziņojumu neizdevās saglabāt. Lūdzu, mēģiniet vēlreiz.', cancel:'Atcelt paziņojumu'}
  };
  document.addEventListener('submit', event => {
    const form = event.target.closest('.restock-alert-form');
    if (!form) return;
    event.preventDefault();
    const saved = saveAlert(form);
    // An AI agent submitting the form as a WebMCP tool gets the outcome as the tool result
    saved.catch(() => {}); // failures are already shown in the form
    if (event.agentInvoked) event.respondWith(saved);
  });
  // Resolves with a confirmation, or rejects when the alert could not be saved
  async function saveAlert(form) {
    const status = form.querySelector('.restock-alert-status');
    const button = form.querySelector('button[type="submit"]');
    const lang = (form.dataset.locale || 'en').slice(0,2);
    const text = messages[lang] || messages.en;
    const variantId = form.querySelector('[data-restock-variant]').value;
    status.hidden = false;
    status.textContent = text.loading;
    button.disabled = true;
    try {
      const response = await fetch(form.action, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({variantId,email:form.elements.email.value,locale:lang,country:form.dataset.country,source:form.dataset.source})});
      const result = await response.json();
      if (!response.ok) throw Error(result.error || text.error);
      const item = [result.product,result.color,result.size].filter(Boolean).join(' · ');
      status.textContent = text.success.replace('{item}',item) + ' ';
      const link = document.createElement('a');
      link.href = result.cancelUrl;
      link.textContent = text.cancel;
      status.append(link);
      return `Back-in-stock alert saved for ${item}.`;
    } catch (error) { status.textContent = text.error; throw Error(text.error); }
    finally { button.disabled = false; }
  }
})();
